import { PublicKey } from "@solana/web3.js";
import {
  getMint,
  getMetadataPointerState,
  getTokenMetadata,
  TOKEN_2022_PROGRAM_ID
} from "@solana/spl-token";

const fetchMetadataJson = async (uri) => {
  try {
    const response = await fetch(uri);
    if (!response.ok) {
      throw new Error(`Failed to fetch metadata JSON from URI: ${uri}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching metadata JSON:", error);
    return null;
  }
};

const validateTokenIcon = (imageUrl) => {
  if (!imageUrl || typeof imageUrl !== "string") {
    console.error(`Invalid token image URL: ${imageUrl}`);
    return null;
  }
  return imageUrl;
};

export const tokenDetails2022 = async (connection, mintAddress) => {
  try {
    // Validate and initialize the mint PublicKey
    const mint = new PublicKey(mintAddress);

    // Fetch mint information
    const mintInfo = await getMint(
      connection,
      mint,
      "confirmed",
      TOKEN_2022_PROGRAM_ID
    );

    // Retrieve metadata pointer state
    const metadataPointer = getMetadataPointerState(mintInfo);
    //console.log("\nMetadata Pointer:", JSON.stringify(metadataPointer, null, 2));

    // Fetch token metadata
    const metadata = await getTokenMetadata(connection, mint);
    //console.log("\nMetadata:", JSON.stringify(metadata, null, 2));

    // Fetch metadata JSON from URI
    const metadataJson = await fetchMetadataJson(metadata.uri);

    // Extract and validate token icon URL
    const tokenIcon = validateTokenIcon(metadataJson.image);

    // Return token details
    return {
      name: metadata.name,
      symbol: metadata.symbol,
      decimals: mintInfo.decimals,
      logo: tokenIcon
    };
  } catch (error) {
    //console.error("Error fetching token details:", error);
    return null;
  }
};

